export default function Achievements() {
    return (
        <div>
            <p className="fs-1 fw-bold">Our achievements</p>
            <div className="container">
                <div className="row">
                    <div className="col-4 col-sm-2 g-3 text-center">
                        <img
                            className="img-fluid"
                            src="./OurAchievements/1.png"
                            alt=""
                        />
                    </div>
                    <div className="col-4 col-sm-2 g-3 text-center">
                        <img
                            className="img-fluid"
                            src="./OurAchievements/2.png"
                            alt=""
                        />
                    </div>
                    <div className="col-4 col-sm-2 g-3 text-center">
                        <img
                            className="img-fluid"
                            src="./OurAchievements/3.png"
                            alt=""
                        />
                    </div>
                    <div className="col-4 col-sm-2 g-4 text-center">
                        <img
                            className="img-fluid"
                            src="./OurAchievements/4.png"
                            alt=""
                        />
                    </div>
                    <div className="col-4 col-sm-2 g-4 text-center">
                        <img
                            className="img-fluid"
                            src="./OurAchievements/5.png"
                            alt=""
                        />
                    </div>
                    <div className="col-4 col-sm-2 g-3 text-center">
                        <img
                            className="img-fluid"
                            src="./OurAchievements/6.png"
                            alt=""
                        />
                    </div>
                </div>
            </div>
        </div>
    )
}
